import React from 'react';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
  >
    <path
      d="M1.40723 1.40723L6.59268 6.59268"
      stroke="white"
      strokeOpacity="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.59268 1.40732L1.40723 6.59277"
      stroke="white"
      strokeOpacity="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
